import React, { useState } from 'react';
import { Link } from "react-router-dom";
import classNames from "classnames";

import Logo from "Components/Logo";
import Nav from "./Nav";
import Profile from "./Profile";

export default function Sidenav({location, user, isPlayer, isEditor}) {

    if (isPlayer) {
        return null;
    }

    const path = location.pathname.split('/');

    const classes = {
        container: classNames(
            "w-16 flex-shrink-0 flex flex-col h-full bg-indigo-700 border-r",
            {
                "lg:w-52": ! isEditor
            }
        ),
        logoLink: classNames(
            'flex items-center justify-center flex-shrink-0 px-4 h-16',
            {
                'lg:h-32': ! isEditor
            }
        )
    };

    return (
        <div className={classes.container}>
            <div className="flex-1 flex flex-col pb-4 overflow-y-auto">
                <Link to='/' className={classes.logoLink}>
                    <Logo className='text-indigo-50 hover:text-white h-8 lg:h-16 my-4' />
                </Link>
                <Nav path={path[1]} minimized={isEditor} />
            </div>

            <Profile user={user} />
        </div>
    )
}
